import { Profile } from './auth.models';

export const roles = {
  Administrator: 'administrator',
  /** The account owner: the one user a reset keeps, and the only one who may reset the account. */
  Owner: 'owner',
};

// Utility function to check if the user is an administrator
export function isAdmin(profile: Profile | null): boolean {
  return profile?.roles.includes(roles.Administrator) ?? false;
}
